export function getPartsFromArray<T>(array: Array<T>, partSize: number = 500): Array<Array<T>> {
  const partsCount = Math.ceil(array.length / partSize);
  return Array.from({ length: partsCount }, (_, index) =>
    array.slice(index * partSize, Math.min(partSize * (index + 1), array.length))
  );
}
